<div class="page-section">
    <div class="page-section-header">
        <h2 class="page-section-title">Player Management</h2>
    </div>
    <div class="page-section-filters">
        <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-primary text-nowrap" (click)="getType('register')"
                [class.active]="type == 'register'">New Member</button>
            <button class="btn btn-outline-primary text-nowrap" (click)="getType('topup')"
                [class.active]="type == 'deposit'">Member First Topup</button>
            <button class="btn btn-outline-primary text-nowrap" (click)="getType('promotion')"
                [class.active]="type == 'promotion'">Promotion</button>
        </div>
        <input type="date" class="form-control form-control-sm" placeholder="From Date" [(ngModel)]="from_date"
            (change)="getPlayers()">
        <input type="date" class="form-control form-control-sm" placeholder="To Date" [(ngModel)]="to_date"
            (change)="getPlayers()" *ngIf="permission.can_report">
        <input type="text" class="form-control form-control-sm" placeholder="Search Player" [(ngModel)]="search_player"
            (input)="filterPlayer()">
    </div>

    <div class="page-section-body" *ngIf="!is_loading">
        <table class="table">
            <thead>
                <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Status</th>
                    <th>Created On</th>
                    <th *ngIf="type == 'register' || type == 'topup'">First Topup Value</th>
                    <th *ngIf="type == 'register' || type == 'topup'">Total Topup</th>
                    <th><span *ngIf="type == 'register' || type == 'topup'">First Deposit On</span><span
                            *ngIf="type == 'promotion'">Promotion</span></th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let player of players">
                    <td class="align-middle">{{player.code}}</td>
                    <td class="align-middle">{{player.name}}</td>
                    <td class="align-middle">{{player.mobile}}</td>
                    <td class="align-middle">
                        <span class="badge d-inline-block" [ngClass]="player.is_suspended == 1 ? 'bg-danger' : player.status ? 'bg-success' : 'bg-secondary'">
                            {{player.is_suspended == 1 ? 'Suspended' : player.status ? 'Active' : 'Inactive'}}
                        </span>
                    </td>
                    <td class="align-middle">{{player.timestamp | date:'medium'}}</td>
                    <td class="align-middle" *ngIf="type == 'register' || type == 'topup'">
                        {{player.first_topup_value ? (player.first_topup_value | number:'1.2-2') : "0.00"}}
                    </td>
                    <td class="align-middle" *ngIf="type == 'register' || type == 'topup'">
                        {{player.total_topup ? (player.total_topup | number:'1.2-2') : "0.00"}}
                    </td>
                    <td class="align-middle">
                        <span *ngIf="type == 'register' || type == 'topup'">{{player.first_topup_on ? (player.first_topup_on
                            | date:'medium') : "-"}}</span>
                        <span *ngIf="type == 'promotion'">{{player.promotion_title}}</span>
                    </td>
                    <td class="align-middle">
                        <button class="btn btn-sm btn-primary btn-sm"
                            [routerLink]="['/lo', company_uuid, 'wallet-topup-withdraw']"
                            [queryParams]="{player: player.uuid, tab: 'bank'}">View</button>
                    </td>
                </tr>
                <tr *ngIf="!players || players.length === 0">
                    <td colspan="9" class="text-center text-muted py-4" style="font-style: italic;">No players found.</td>
                </tr>
                <tr *ngIf="(!players || players.length === 0) && search_player && search_player.length > 0">
                    <td colspan="9" class="text-center text-muted py-3">For search please input player name, code or mobile
                        number. The search function is only applicable to current page data only. <button
                            class="btn btn-sm btn-primary" (click)="search_player = null; players = _players">Clear
                            Search</button></td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="page-section-footer" *ngIf="!is_loading && players.length > 0">
        <span>Total <span *ngIf="type == 'register' || type == 'topup'">Players</span><span *ngIf="type == 'promotion'">Promotions</span>:</span>
        <span class="page-section-stat">{{players.length}}</span>
    </div>
</div>
